import axios from "axios"

import { parseJapaneseDate } from "@p-ban/common/src/utils/DateUtils"

export const END_POINT = {
  WHATS_NEW: "/inc/whatsnew.inc",
  ACHIEVEMENT: "/information/gc.json",
  ANSWER_CHAN: "/inc/answer_chan.inc",
} as const

const staticSiteApi = {
  async whatsNew() {
    const { data: htmlString } = await axios.get<string>(END_POINT.WHATS_NEW)
    const doc = new DOMParser().parseFromString(htmlString, "text/html")
    const dateString = doc.querySelector("dt")?.textContent

    return {
      lastUpdated: dateString ? parseJapaneseDate(dateString) : null,
    }
  },
  async achievementApi() {
    const { data } = await axios.get<[unknown, number, number][]>(END_POINT.ACHIEVEMENT)

    const latestAchievement = data[data.length - 1] as [unknown, number, number]

    return {
      numberOfTradingCompanies: latestAchievement[1],
      deliveryDateComplianceRate: latestAchievement[2],
    }
  },
  async answerChan() {
    const { data } = await axios.get<string>(END_POINT.ANSWER_CHAN)
    return {
      html: data,
    }
  },
} as const

export default staticSiteApi
